// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ActivityState, PlayerMapping, TrainingRoom} from "@models";
import {SimSystemExtendedService} from "@services";
import {Translations} from "@translations";
import {EventEmitterService} from "@event-emitter";

export interface DialogData_PlayerSelectionDialog extends MatDialogDataBaseInput {
	trainingRoom: TrainingRoom;
	selectedPlayers?: string[];
	multiSelect?: boolean;
}

export interface DialogData_PlayerSelectionDialogOutput extends MatDialogDataBaseOutput {
	selectedPlayer?: PlayerMapping;
	selectedPlayers?: string[];
}

@Component({
	selector: "sim-player-selection-dialog",
	templateUrl: "./player-selection-dialog.component.html",
	styleUrls: ["./player-selection-dialog.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class PlayerSelectionDialogComponent
	extends BasicMaterialDialog<PlayerSelectionDialogComponent, DialogData_PlayerSelectionDialog, DialogData_PlayerSelectionDialogOutput>
	implements OnInit
{
	T = Translations;
	ActivityState = ActivityState;

	constructor(
		private _injector: Injector,
		private _simSystemService: SimSystemExtendedService,
		private _emitterService: EventEmitterService,
	) {
		super(_injector);
	}

	public ngOnInit() {
		super.ngOnInit();

		this._emitterService.onPlayerStateChanged.subscribe((args) => {
			if (args) {
				let playerToUpdate = args.player;

				this.data?.trainingRoom?.debriefingPlayers.forEach((debPlayer) => {
					if (debPlayer.id === playerToUpdate.id) {
						Object.assign(debPlayer, playerToUpdate);
					}
				});
			}
		});
	}

	public selectPlayer(playerInfo: PlayerMapping) {
		if (this.data.multiSelect) {
			if (this.data.selectedPlayers?.some((playerId) => playerId === playerInfo.id)) {
				//Deselect -> remove from list
				const playersIndex = this.data.selectedPlayers.indexOf(playerInfo.id, 0);
				this.data.selectedPlayers.splice(playersIndex, 1);
			} else {
				this.data.selectedPlayers.push(playerInfo.id);
			}
		} else {
			this.close({selectedPlayer: playerInfo, action: "ok"});
		}
	}

	playerAlreadySelected(playerParam: PlayerMapping) {
		return this.data.selectedPlayers?.some((playerId) => playerId === playerParam.id);
	}
}
